//AnnotationTool.js

import EditNoteIcon from "@mui/icons-material/EditNote";

export const ArrowAnnotateToolConfig = {
  name: "ANNOTATION",
  tool: "ArrowAnnotate",  
  icon: <EditNoteIcon  />,
};